module.exports = __webpack_public_path__ + "img/sack-pellets.e273d90.webp";